const useTranslations =
  (componentName) =>
  (scope, options = {}) => {
    const translationScope =
      scope.charAt(0) === '.' ? `${componentName}${scope}` : scope;

    return window.I18n.t(translationScope, options);
  };

export default useTranslations;
